module.exports = __webpack_public_path__ + "img/icon-box.07d602da.svg";